import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateUserModal from '@modals/CreateUserModal/CreateUserModal'
import FindAgentModal from '@modals/FindAgentModal'
import ImportUsersModal from '@modals/ImportUsersModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateUserModal: {
      closeModal: () => setState({ showCreateUserModal: false }),
      createUser: payload => handleCallbackAction(payload),
    },
    FindAgentModal: {
      closeModal: () => setState({ showFindAgentModal: false }),
    },
    ImportUsersModal: {
      closeModal: () => setState({ showImportUsersModal: false }),
      importUsers: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateUserModal: false,
  showFindAgentModal: false,
  showImportUsersModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateUserModal, showFindAgentModal, showImportUsersModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      generateReport: payload => handleCallbackAction(payload),
      showCreateUserModal: (payload) => {
        setModalData('CreateUserModal', payload)
        setState({ showCreateUserModal: true })
      },
      showFindAgentModal: (payload) => {
        setModalData('FindAgentModal', payload)
        setState({ showFindAgentModal: true })
      },
      showImportUsersModal: (payload) => {
        setModalData('ImportUsersModal', payload)
        setState({ showImportUsersModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateUserModal
          callbacks={callbacks('CreateUserModal', setState)}
          showModal={showCreateUserModal}
        />

        <FindAgentModal
          callbacks={callbacks('FindAgentModal', setState)}
          showModal={showFindAgentModal}
        />

        <ImportUsersModal
          callbacks={callbacks('ImportUsersModal', setState)}
          showModal={showImportUsersModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
